module.exports = __webpack_public_path__ + "img/store.e71a3cc3.png";